import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/layouts/MainLayout.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
    meta: { public: true }
  },
  {
    path: '/setup-password',
    name: 'SetupPassword',
    component: () => import('@/views/SetupPasswordView.vue'),
    meta: { public: true }
  },
  {
    path: '/dashboard/assetdevices/:id',
    name: 'AssetDevices',
    component: () => import('@/views/dashboard/AssetDevices.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard/devicechart/:id',
    name: 'DeviceChart',
    component: () => import('@/views/dashboard/DeviceChart.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard/devicedashboard/:id',
    name: 'DeviceDashboard',
    component: () => import('@/views/dashboard/DeviceDashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/cardashboard/history/:id',
    name: 'CarHistory',
    component: () => import('@/views/dashboard/CarHistory.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/cardashboard/settings/:id',
    name: 'CarSettings',
    component: () => import('@/views/dashboard/CarSettings.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/cardashboard/chart/:id',
    name: 'CarChart',
    component: () => import('@/views/dashboard/CarChart.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/cardashboard/:id',
    name: 'CarDashboard',
    component: () => import('@/views/dashboard/CarDashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: { name: 'ColdChainAll' }
      },
      {
        path: 'coldchainAll',
        name: 'ColdChainAll',
        component: () => import('@/views/coldchainAll.vue')
      },
      {
        path: 'coldchainMap',
        name: 'ColdChainMap',
        component: () => import('@/views/coldchainMap.vue')
      },
      // Settings
      {
        path: 'settings/cars',
        name: 'Cars',
        component: () => import('@/views/settings/Cars.vue')
      },
      {
        path: 'settings/companies',
        name: 'Companies',
        component: () => import('@/views/settings/Companies.vue')
      },
      {
        path: 'settings/users',
        name: 'Users',
        component: () => import('@/views/settings/Users.vue')
      },
      {
        path: 'settings/user-companies',
        name: 'UserCompanies',
        component: () => import('@/views/settings/UserCompanies.vue')
      },
      {
        path: 'settings/plans',
        name: 'Plans',
        component: () => import('@/views/settings/Plans.vue')
      },
      {
        path: 'settings/plans/:id',
        name: 'PlanDetail',
        component: () => import('@/views/settings/PlanDetail.vue')
      },
      {
        path: 'settings/drivers',
        name: 'Drivers',
        component: () => import('@/views/settings/Drivers.vue')
      },
      {
        path: 'settings/groups',
        name: 'Groups',
        component: () => import('@/views/settings/Groups.vue')
      },
      {
        path: 'page1',
        name: 'Customers',
        component: () => import('@/views/Page1View.vue')
      },
      {
        path: 'page2',
        name: 'Opportunities',
        component: () => import('@/views/Page2View.vue')
      },
      {
        path: 'page3',
        name: 'Calendar',
        component: () => import('@/views/Page3View.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Route Guard
// Note: visiting /login while a token is already stored is intentionally
// allowed through — LoginView itself verifies the token against /auth/me
// and only redirects to "/" once that check actually succeeds.
router.beforeEach((to, from, next) => {
  const isPublic = to.meta.public
  const isLoggedIn = !!localStorage.getItem('accessToken')

  if (!isPublic && !isLoggedIn) return next('/login')
  next()
})

export default router
